import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import WhereModal from "../../Components/WhereModal/whereModal";
import WhenModal from "../../Components/WhenModal/whenModal";

const Schedule = () => {
  const [isWhereModalOpen, setIsWhereModalOpen] = useState<boolean>(false);
  const [isWhenModalOpen, setIsWhenModalOpen] = useState<boolean>(false);

  return (
    <div id="schedule">
      <WhereModal
        isOpen={isWhereModalOpen}
        handleClose={() => setIsWhereModalOpen(false)}
      />
      <WhenModal
        isOpen={isWhenModalOpen}
        handleClose={() => setIsWhenModalOpen(false)}
      />
      <div
        style={{
          display: "flex",
          width: "100vw",
          backgroundColor: "#F7F8F5CC",
          paddingBottom: "4rem",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            flex: 1,
            padding: "0rem 2rem",
            marginTop: "2rem",
          }}
        >
          <Typography fontFamily="Crimson Pro" variant="h5">
            WHEN
          </Typography>
          <Typography variant="h4" padding={2} textAlign="center">
              Friday,&nbsp;
              <span
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                August 7th
                <span
                  style={{
                    position: "absolute",
                    left: "-5%",
                    top: "50%",
                    width: "110%",
                    height: "2px",
                    backgroundColor: "red",
                    transform: "rotate(-10deg)",
                    transformOrigin: "center",
                    pointerEvents: "none",
                  }}
                />
              </span>
              <br/>
                <span
                style={{
                  fontFamily: "'Caveat', 'Comic Sans MS', cursive",
                  color: "#b71c1c",
                  fontSize: "1.1em",
                  transform: "rotate(-2deg)",
                  display: "inline-block",
                  marginLeft: "1rem",
                }}
              >
                November 13th
              </span> 2026
            </Typography>
            <div
            style={{
              minHeight: "65px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" textAlign={"center"}>
             1:00pm - 1:00am
            </Typography>
          </div>
    
          <Button
            style={{ marginTop: "1rem" }}
            variant="outlined"
            endIcon={<InfoOutlined />}
            onClick={() => setIsWhenModalOpen(true)}
          >
            FULL DETAILS
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            flex: 1,
            padding: "0rem 2rem",
            marginTop: "2rem",
          }}
        >
          <Typography fontFamily="Crimson Pro" variant="h5">
            WHERE
          </Typography>
          <Typography variant="h4" padding={2} textAlign={"center"}>
            Dalmeny Park House Hotel
          </Typography>
          <div
            style={{
              minHeight: "65px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" textAlign={"center"}>
              Lochlibo Road, Barrhead, G78 1LG
            </Typography>
          </div>
          <Button
            style={{ marginTop: "1rem" }}
            variant="outlined"
            endIcon={<InfoOutlined />}
            onClick={() => setIsWhereModalOpen(true)}
          >
            FULL DETAILS
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
